import { render, staticRenderFns } from "./APIDocs.vue?vue&type=template&id=e66d1a4c"
import script from "./APIDocs.vue?vue&type=script&lang=js"
export * from "./APIDocs.vue?vue&type=script&lang=js"
import style0 from "./APIDocs.vue?vue&type=style&index=0&id=e66d1a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports